import React, {useEffect} from 'react';
import throttle from 'lodash.throttle';

interface MouseMoveHandlerProps {
    clientX: number;
    clientY: number;
}

type MouseMouseHandler = (props: MouseMoveHandlerProps) => void;

export const useMouseMove = (
    handler: MouseMouseHandler | undefined,
    elementRef: React.MutableRefObject<HTMLDivElement | null>
): void => {
    useEffect(
        () => {
            // Make sure element supports addEventListener
            const isSupported = elementRef && elementRef.current;
            if (!isSupported) return;

            const eventListener = (event) => {
                if (handler) {
                    handler(event);
                }
            };

            const throttledListener = throttle(eventListener, 25);

            // Add event listener
            if (elementRef.current) {
                elementRef.current.addEventListener('mousemove', throttledListener);
            }

            // Remove event listener on cleanup
            return () => {
                if (elementRef && elementRef.current) {
                    elementRef.current.removeEventListener('mousemove', throttledListener);
                }
            };
        },
        [elementRef, handler] // Re-run if element changes
    );
};
